import { formatAcceptText, formatMaxSizeLabel } from './fileFormatters';
import { mimeTypeMap } from './mimeTypes';
const XML_MIME_TYPES = ['application/xml', 'text/xml'];
const PKCS12_MIME_TYPES = ['application/x-pkcs12', 'application/pkcs12'];
export const validateFileFormat = (file, acceptTypes, t) => {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    const certificateWithoutMime = file.type === '' && (fileExtension === 'pfx' || fileExtension === 'p12') && acceptTypes.includes(fileExtension);
    if (certificateWithoutMime)
        return null;
    const allowedMimeTypes = acceptTypes.flatMap(ext => {
        if (ext === 'xml')
            return XML_MIME_TYPES;
        if (ext === 'pfx' || ext === 'p12')
            return PKCS12_MIME_TYPES;
        return [mimeTypeMap[ext] ?? `image/${ext}`];
    });
    if (!allowedMimeTypes.includes(file.type)) {
        return `${t('file-upload.error.invalid-format.prefix')}${formatAcceptText(acceptTypes)}`;
    }
    return null;
};
export const validateFileSize = (file, maxSizeKB, t) => {
    const sizeKB = file.size / 1024;
    if (sizeKB > maxSizeKB) {
        return `${t('file-upload.error.invalid-size.prefix')}${formatMaxSizeLabel(maxSizeKB)}`;
    }
    return null;
};
export const validateImageDimensions = (file, maxWidth, maxHeight, t) => {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
            if (img.width > maxWidth || img.height > maxHeight) {
                resolve(`${t('file-upload.error.invalid-dimensions.prefix')}${maxWidth}x${maxHeight}px`);
            }
            else {
                resolve(null);
            }
        };
        img.onerror = () => resolve(t('file-upload.error.read'));
        img.src = URL.createObjectURL(file);
    });
};
